<template>
  <div class="group-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
          v-model="searchParams.prodNameLike"
          :placeholder="$t('group.productNamePlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="margin-top"
    >
      <el-table-column prop="groupId" :label="$t('adminGroupOrder.orderId')" align="center"></el-table-column>
      <el-table-column :label="$t('adminGroupOrder.productImage')" align="center">
        <template #default="scope">
          <el-image
            style="width: 50px; height: 50px; border-radius: 10px;"
            :src="scope.row.coverPhoto"
            fit="cover"
          >
            <template #error>
              <div class="image-error">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="prodName" :label="$t('adminGroupOrder.productName')" align="center"></el-table-column>
      <el-table-column prop="userCount" :label="$t('adminGroupOrder.buyCount')" align="center"></el-table-column>
      <el-table-column prop="groupPrice" :label="$t('adminGroupOrder.groupAmount')" align="center">
        <template #default="scope">
          {{ `￥${scope.row.groupPrice}` }}
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('adminGroupOrder.singlePrice')" align="center">
        <template #default="scope">
          {{ `￥${scope.row.price}` }}
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('adminGroupOrder.status')" align="center">
        <template #default="scope">
          {{ scope.row.state === '1001' ? $t('common.enable') : $t('common.disable') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminGroupOrder.validDate')" align="center">
        <template #default="scope">
          {{ `${scope.row.startTime}~${scope.row.endTime}` }}
        </template>
      </el-table-column>
      <el-table-column prop="rebateFlag" :label="$t('adminGroupOrder.hasRebate')" align="center">
        <template #default="scope">
          {{ scope.row.rebateFlag === 'Y' ? $t('common.yes') : $t('common.no') }}
        </template>
      </el-table-column>
      <el-table-column prop="rebate" :label="$t('adminGroupOrder.leaderRebate')" align="center">
        <template #default="scope">
          {{ `${scope.row.rebate}%` }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="margin-top"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import { getGroupList } from '@/api/group/groupApi'

export default {
  name: 'AShopDetailGroup',

  data() {
    return {
      searchParams: {
        prodNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        
        const res = await getGroupList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取拼团商品列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.group-container {
}
.search-row {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  color: #999;
}
</style>